<template>
  <div>
    <CCard class="bg-style2 mt-3">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem;">
        <span class="font-weight-bold h6">
          <CIcon v-if="icon" :name="icon" /> {{ caption }}
        </span>
        <div class="card-header-actions">
          Total: {{ voteSummary }}
        </div>
      </CCardHeader>

      <CCardBody style="position: relative;">
        <CRow>
          <CCol>
            <CDataTable
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :dark="dark"
                :loading="loading"
                :items="tableData"
                :fields="fields"
                :items-per-page="20"
                pagination
            >
              <template #index="{ index }">
                <td class="text-center">{{ index + 1 }}</td>
              </template>
              <template #votes="{ item }">
                <td class="text-center">{{ item.votes }}</td>
              </template>
              <template #percentage="{ item }">
                <td class="text-center">{{ item.percentage }}%</td>
              </template>
              <template #year="{ item }">
                <td class="text-center">{{ item.year }}</td>
              </template>
            </CDataTable>

            <!-- ✅ Abstention Info (bottom-right, no bg, text-dark) -->
            <div
                v-if="abstentionCount > 0"
                class="d-flex justify-content-end"
                style="margin-top: 1.25rem; font-weight: bold; font-size: 0.95rem; color: #212529;"
            >
              Abstention: {{ abstentionCount }} ({{ abstentionPercentage }}%)
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import api from '@/service/api.js'
import { CIcon } from '@coreui/vue'

export default {
  name: 'TableVote',
  components: { CIcon },

  props: {
    icon: { type: String, default: 'cil-chart-pie' },
    caption: { type: String, default: 'Candidate Voting Result' },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading: { type: Boolean, default: false },
    selectedType: { type: String, default: '' },
    selectedYear: { type: [String, Number], default: '' }
  },

  data() {
    return {
      allData: [],
      voteSummary: '0',
      abstentionCount: 0,
      abstentionPercentage: '0.00'
    }
  },

  computed: {
    fields() {
      return [
        { key: 'index', label: 'No.', _style: 'width:60px; text-align:center' },
        { key: 'name', label: 'Name' },
        { key: 'studentId', label: 'Student ID' },
        { key: 'department', label: 'Department' },
        { key: 'major', label: 'Major' },
        { key: 'candidateType', label: 'Candidate Type' },
        { key: 'year', label: 'Year', _style: 'text-align:center' },
        { key: 'votes', label: 'Votes', _style: 'text-align:center' },
        { key: 'percentage', label: 'Percentage', _style: 'text-align:center' }
      ]
    },

    tableData() {
      let candidates = []
      let abstention = 0
      let totalVotesInType = 0

      const selectedYear = Number(this.selectedYear) || new Date().getFullYear()

      if (!this.selectedType) {
        for (const block of this.allData) {
          const year = block.year || new Date().getFullYear()
          if (year !== selectedYear) continue

          totalVotesInType += block.candidates.reduce((sum, c) => sum + c.votes, 0) + (block.abstention || 0)
          candidates = [...candidates, ...block.candidates.map(c => ({ ...c, year }))]
          abstention += block.abstention || 0
        }
      } else {
        const filtered = this.allData.find(b => b.type === this.selectedType && (b.year || new Date().getFullYear()) === selectedYear)
        if (filtered) {
          const year = filtered.year || new Date().getFullYear()
          totalVotesInType = filtered.candidates.reduce((sum, c) => sum + c.votes, 0) + (filtered.abstention || 0)
          candidates = filtered.candidates.map(c => ({ ...c, year }))
          abstention = filtered.abstention || 0
        }
      }

      this.abstentionCount = abstention
      this.abstentionPercentage = totalVotesInType ? ((abstention / totalVotesInType) * 100).toFixed(2) : '0.00'

      return candidates.map(c => ({
        ...c,
        percentage: totalVotesInType ? ((c.votes / totalVotesInType) * 100).toFixed(2) : '0.00'
      }))
    }
  },

  methods: {
    async fetchData() {
      try {
        const res = await api.vote('getVoteCounts')
        this.allData = res?.data?.data || []
        this.voteSummary = res?.data?.total || '0'
      } catch (e) {
        console.error('Failed to fetch vote counts:', e)
      }
    }
  },

  created() {
    this.fetchData()
  }
}
</script>
